var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43934 12.4394C9.02512 11.8535 9.97488 11.8535 10.5607 12.4394L15.5 17.3786L20.4394 12.4394C21.0252 11.8535 21.9748 11.8535 22.5606 12.4394C23.1465 13.0252 23.1465 13.9748 22.5606 14.5606L16.5606 20.5607C15.9748 21.1464 15.0252 21.1464 14.4394 20.5607L8.43934 14.5606C7.85355 13.9748 7.85355 13.0252 8.43934 12.4394Z",
    fill: "#A09F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.23de6b60ce9a9e2e25808465c97bace6.svg";
export { ForwardRef as ReactComponent };